import React, { Component } from "react";

class TableColumn extends Component {
  render() {
  
    return (
      <div className="col-xs-3">
        <h3>
          <span className={`float-left ${this.props.HD !== "N/A" && this.props.HD.indexOf("/") > -1 ? 'small-font' : ''}`}>{this.props.HD}</span>
          <span className={`float-right ${this.props.SD !== "N/A" && this.props.SD.indexOf("/") > -1 ? 'small-font' : ''}`}>{this.props.SD}</span>
        </h3>
      </div>
    );
  }
}

export default TableColumn;



// WEBPACK FOOTER //
// ./src/components/TableColumn.js